import CompetencyCourse from "@/components/training/CompetencyCourse";
import { tdarResultsCourse } from "@/data/longhandCompetencyCourses";

const TDARResultsFormula = () => <CompetencyCourse course={tdarResultsCourse} />;

export default TDARResultsFormula;
